import React from 'react';
import { Dialog, DialogContent, DialogTitle, Stack, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import PaiIconButton from 'features/ui/base-components/pai-icon-button';
import EmailSendersTab from './email-senders-tab';
import { LinkedinAccount } from './linkedin-accounts.types';

interface Props {
  open: boolean;
  token: string;
  account: LinkedinAccount | null;
  onClose(): void;
  onEditLegacy?(account: LinkedinAccount): void;
  onRemoveLegacy?(account: LinkedinAccount): void;
}

const ManageEmailSendersDialog: React.FC<Props> = ({ open, account, onClose, onEditLegacy, onRemoveLegacy }) => {
  if (!account) return null;
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle sx={{ m: 0, p: 2 }}>
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Typography variant="h6">Manage E-mail Senders</Typography>
          <PaiIconButton size="small" variant="regular" onClick={onClose} aria-label="close">
            <CloseIcon />
          </PaiIconButton>
        </Stack>
      </DialogTitle>
      <DialogContent dividers>
        <EmailSendersTab
          account={account}
          onEditLegacy={() => onEditLegacy?.(account)}
          onRemoveLegacy={() => onRemoveLegacy?.(account)}
        />
      </DialogContent>
    </Dialog>
  );
};

export default ManageEmailSendersDialog;